import React from 'react';
import { motion } from 'framer-motion';
const weeks = [{
  num: 1,
  title: 'Semana 1 · Comunicación Base',
  desc: 'Introducir los primeros 20 pictogramas del Tomo 1. Necesidades básicas: agua, comida, baño, ayuda, descanso.'
}, {
  num: 2,
  title: 'Semana 2 · Rutinas Visuales',
  desc: 'Implementar la agenda visual de mañana y noche del Tomo 2. Las dos rutinas que más conflicto generan en el hogar.'
}, {
  num: 3,
  title: 'Semana 3 · Emociones y Regulación',
  desc: 'Introducir el Semáforo Emocional del Tomo 3. Para que el niño pueda decirte cómo está antes de explotar.'
}, {
  num: 4,
  title: 'Semana 4 · Autonomía y Mundo Exterior',
  desc: 'Preparar la primera salida con el Kit de Bolsillo. Entregar el Manual Escolar a la maestra. Primera Historia Social.'
}];
export function ThirtyDayPlan() {
  return;
}